import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import { mainLayout, popupsLayout, SettingsLayout } from "./layouts";

// Route Views
import Errors from "./views/Errors";
import login from "./views/login";
import forgetPassword from "./views/forgetPassword";
import Settings from "./views/Settings/Settings";

export default [
  {
    path: "/",
    exact: true,
    layout: mainLayout,
    component: () => <Redirect to="/login" />,
  },
  {
    path: "/login",
    layout: popupsLayout,
    component: login,
  },
  {
    path: "/forgetPassword",
    layout: popupsLayout,
    component: forgetPassword,
  },
  {
    path: "/settings",
    layout: SettingsLayout,
    component: Settings,
  },
  {
    path: "/errors",
    layout: mainLayout,
    component: Errors,
  },
];
